// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Form, Row, Col, Button, Table, Card } from 'react-bootstrap';
// import Select from 'react-select';
// import { BASE_URL } from '../../services/Api';
// import { authHeader } from '../../services/auth-header';
// import debounce from 'lodash/debounce';
// import Swal from 'sweetalert2';
// import { Link, useNavigate } from 'react-router-dom';

// const PIssueSlipCreate = () => {
//   const navigate = useNavigate();

//   const [issueslipdate, setissueslipdate] = useState(new Date().toISOString().split('T')[0]);
//   const [stocktype, setSelectedstocktype] = useState({ value: 'outward', label: 'Outward' });

//   const [storeInchargeSearch, setStoreInchargeSearch] = useState(encodeURIComponent(" "));
//   const [customers, setCustomers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);

//   const [supervisorSearch, setSupervisorSearch] = useState(encodeURIComponent(" "));
//   const [staff, setStaff] = useState([]);
//   const [selectedStaff, setSelectedStaff] = useState([]);

//   const [productionOrderSearch, setProductionOrderSearch] = useState(encodeURIComponent(" "));
//   const [productionOrders, setProductionOrders] = useState([]);
//   const [selectedProductionOrder, setSelectedProductionOrder] = useState(null);
//   const [PumpRawSemiProductOptions, setPumpRawSemiProductOptions] = useState([]);
//   const [selectedPumpRawSemiProduct, setselectedPumpRawSemiProduct] = useState(null);
//   const [productTableRaw, setproductTableRaw] = useState([]);

//   const handleSearchStoreIncharge = debounce((inputValue) => {
//     setStoreInchargeSearch(encodeURIComponent(inputValue));
//   }, 500);

//   const handleSearchSupervisor = debounce((inputValue) => {
//     setSupervisorSearch(encodeURIComponent(inputValue));
//   }, 500);

//   const handleSearchProductionOrder = debounce((inputValue) => {
//     setProductionOrderSearch(encodeURIComponent(inputValue));
//   }, 500);

//   const fetchStoreIncharges = async () => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}staff/page/0/10/asc/id/${storeInchargeSearch}`,
//         { headers: authHeader() }
//       );

//       const staffMembers = response.data.Index || response.data.data;
//       setCustomers(
//         staffMembers.map((staff) => ({
//           value: staff.id,
//           label: `${staff.firstname} ${staff.lastname}`,
//         }))
//       );
//       // const list = res.data.Index || res.data.data;
//       // setCustomers(list.map(item => ({
//       //   value: item.id,
//       //   label: `${staff.firstname} ${staff.lastname}`,
//       // })));  
//     } catch (error) {
//       console.error("Error fetching store incharges", error);
//     }
//   };

//   const fetchSupervisors = async () => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}staff/page/0/10/asc/id/${supervisorSearch}`,
//         { headers: authHeader() }
//       );
//       const staffMembers = response.data.Index || response.data.data;
//       setStaff(
//         staffMembers.map((staff) => ({
//           value: staff.id,
//           label: `${staff.firstname} ${staff.lastname}`,
//         }))
//       );
//       // const list = res.data.Index || res.data.data;
//       // setStaff(list.map(item => ({
//       //   value: item.id,
//       //   label: `${staff.firstname} ${staff.lastname}`,
//       // })));
//     } catch (error) {
//       console.error("Error fetching supervisors", error);
//     }
//   };


//   const fetchProductionOrders = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}productionorder/bytype/page/0/10/asc/id/pump/${productionOrderSearch}`, {
//         headers: authHeader(),
//       });

//       const list = res.data.Index || res.data.data;

//       setProductionOrders(list.map(item => ({
//         value: item.productionordernumber,
//         label: `${item.productionordernumber}-${item.productname} - ${item.jobnumber} - ${item.partno}-${item.quantity}-${item.size}`,
//         jobnumber: item.jobnumber,
//         partno: item.partno
//       })));

//     } catch (error) {
//       console.error("Error fetching production orders", error);
//     }
//   };

//   const fetchMaterialIssueSlipData = async (productId, productionOrderNumber) => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}materialissueslip/getMaterialIssueSlip/Pump/WithProductAndPoNo/${productId}/${productionOrderNumber}`,
//         { headers: authHeader() }
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching material issue slip data", error);
//       return [];
//     }
//   };

//   const handleProductionOrderSelect = (selected) => {
//     setSelectedProductionOrder(selected);
//     if (selected?.value) {
//       getPumpRawSemiProductProductData(selected.value);
//     }
//   };


//   const getPumpRawSemiProductProductData = async (productionordernumber) => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}productionorder/bomitemsbyproductionordernumber/${productionordernumber}`,
//         { headers: authHeader() }
//       );

//       const popumpitems = response.data?.popumpitems || [];

//       if (!popumpitems.length) {
//         setPumpRawSemiProductOptions([]);
//         return;
//       }

//       const finishedbom = popumpitems[0]?.finishedbom;

//       if (!finishedbom || !finishedbom.bomPumpPartsItemsRawSemiService) {
//         setPumpRawSemiProductOptions([]);
//         return;
//       }

//       const pumpRawSemi = finishedbom.bomPumpPartsItemsRawSemiService;

//       const options = pumpRawSemi.map((item) => ({
//         value: item.product.id,
//         label: item.description || `Item ${item.id}`,
//         size: item.size || '',
//         moc: item.moc || '',
//         pumprequiredquantity: item.pumprequiredquantity || '',
//         uom: item.uom || '',
//         rate: item.rate || ''
//       }));

//       setPumpRawSemiProductOptions(options);
//     } catch (error) {
//       console.error('Error fetching tubing raw material from finishedbom', error);
//     }
//   };
//   const handlePumpRawSemiProductSelect = async (selected) => {
//     setselectedPumpRawSemiProduct(selected);

//     // Check if the selected item already exists in the productTableRaw
//     const isAlreadyAdded = productTableRaw.some(
//       (item) => item.pumpPartItems.value === selected.value
//     );

//     if (isAlreadyAdded) {
//       Swal.fire({
//         icon: 'warning',
//         title: 'Duplicate Entry',
//         text: 'This raw material item is already added!',
//       });
//       return;
//     }

//     if (selected && selectedProductionOrder) {
//       const materialSlipData = await fetchMaterialIssueSlipData(
//         selected.value,
//         selectedProductionOrder.value
//       );

//       const totalConsumed = materialSlipData
//         .filter(item => item.product === selected.value)
//         .reduce((sum, item) => sum + parseFloat(item.issuedquantity || 0), 0);

//       const required = parseFloat(selected.pumprequiredquantity || 0);
//       const issuedquantity = "";
//       const available = required - totalConsumed;

//       setproductTableRaw((prevRows) => [
//         ...prevRows,
//         {
//           pumpPartItems: selected,
//           description: selected.label,
//           size: selected.size || '',
//           moc: selected.moc || '',
//           pumprequiredquantity: required,
//           userIssuedQty: issuedquantity,
//           totalConsumed: totalConsumed,
//           availableQty: available,
//           uom: selected.uom || '',
//           rate: selected.rate || '',
//           remarks: ''
//         }
//       ]);
//     }
//   };


//   const handleRawSemiInputChanges = (index, field, value) => {
//     const updatedRows = [...productTableRaw];
//     const row = updatedRows[index];

//     if (field === 'userIssuedQty' || field === 'pumprequiredquantity') {
//       const userInput = parseFloat(value || 0);
//       const requiredQty = parseFloat(row.pumprequiredquantity || 0);
//       const totalConsumed = parseFloat(row.totalConsumed || 0);
//       const totalIssued = userInput + totalConsumed;

//       if (totalIssued > requiredQty) {
//         Swal.fire({
//           icon: 'warning',
//           title: 'Quantity Limit Exceeded',
//           html: `Required quantity is <strong>${requiredQty}</strong>.<br>Total issued (entered + already used) is <strong>${totalIssued}</strong>.<br>Please enter a valid quantity.`,
//         });

//         return;
//       }

//       if (field === 'userIssuedQty') {
//         updatedRows[index]['userIssuedQty'] = value;
//       } else {
//         updatedRows[index][field] = userInput;
//       }

//       updatedRows[index]['availableQty'] =
//         parseFloat(updatedRows[index]['pumprequiredquantity'] || 0) -
//         (parseFloat(updatedRows[index]['userIssuedQty'] || 0) + totalConsumed);
//     } else {
//       updatedRows[index][field] = value;
//     }

//     setproductTableRaw(updatedRows);
//   };

//   const handleRawSemiRemoveRow = (index) => {
//     const updatedRows = productTableRaw.filter((_, rowIndex) => rowIndex !== index);
//     setproductTableRaw(updatedRows);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!selectedProductionOrder) {
//       alert('Please select a production order.');
//       return;
//     }

//     const payload = {
//       type: "Pump",
//       issueslipdate,
//       stocktype: stocktype?.value || '',
//       issuedby: selectedCustomer.map(staff => ({ id: staff.value })),
//       receivedby: selectedStaff.map(staff => ({ id: staff.value })),
//       productionordernumber: selectedProductionOrder.value,
//       jobnumber: selectedProductionOrder.jobnumber,
//       partno: selectedProductionOrder.partno,
//       warehouse: {
//         id: "1" // Assuming warehouse ID is 1, adjust as necessary
//       },

//       materialissuewithbomrawsemiservicespump: productTableRaw.map(row => ({
//         product: {
//           id: row.pumpPartItems.value
//         },
//         partname: row.partname || "",
//         description: row.description || '',
//         materialsize: row.size || '',
//         moc: row.moc || '',
//         requiredquantity: row.pumprequiredquantity || '',
//         issuedquantity: row.userIssuedQty || '',
//         uom: row.uom || '',
//         rate: row.rate || '',
//         remark: row.remarks
//       }))
//     };

//     console.log(payload)

//     try {
//       const response = await axios.post(`${BASE_URL}materialissueslip`, payload, {
//         headers: authHeader()
//       });

//       Swal.fire({
//         icon: 'success',
//         title: 'Success',
//         text: 'Data submitted successfully!',
//         confirmButtonText: 'OK'
//       }).then(() => {
//         navigate("/issue-slip-list/1");
//       });

//     } catch (error) {
//       console.error("Error submitting data", error);
//       Swal.fire({
//         icon: 'error',
//         title: 'Oops...',
//         text: 'Failed to submit data.',
//         confirmButtonText: 'Try Again'
//       });
//     }
//   };

//   useEffect(() => {
//     fetchStoreIncharges();
//   }, [storeInchargeSearch]);

//   useEffect(() => {
//     fetchSupervisors();
//   }, [supervisorSearch]);

//   useEffect(() => {
//     fetchProductionOrders();
//   }, [productionOrderSearch]);

//   return (
//     <div className="Container">
//       <Card className="card">
//         <Card.Header className="card-header">
//           <h6>MATERIAL ISSUE SLIP</h6>
//           <Link to="/issue-slip-list/1">
//             <button className="button-70">BACK</button>
//           </Link>
//         </Card.Header>
//         <div className="container">
//           <br />
//           <Form onSubmit={handleSubmit}>
//             <Row>
//               <Col md="6">
//                 <Form.Group>
//                   <Form.Label>Production Order Number</Form.Label>
//                   <Select
//                     options={productionOrders}
//                     onChange={handleProductionOrderSelect}
//                     onInputChange={handleSearchProductionOrder}
//                     value={selectedProductionOrder}
//                     placeholder="Search or select production order"
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: base => ({ ...base, zIndex: 9999 })
//                     }}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md="6">
//                 <Form.Group>
//                   <Form.Label>Stock Type</Form.Label>
//                   <Select
//                     options={[{ value: 'inward', label: 'Inward' }, { value: 'outward', label: 'Outward' }]}
//                     onChange={setSelectedstocktype}
//                     value={stocktype}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md="6">
//                 <Form.Group>
//                   <Form.Label>Issue Slip Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={issueslipdate}
//                     onChange={(e) => setissueslipdate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md="6">
//                 <Form.Group>
//                   <Form.Label>Issued By (Store Incharge)</Form.Label>
//                   <Select
//                     isMulti
//                     options={customers}
//                     onChange={setSelectedCustomer}
//                     onInputChange={handleSearchStoreIncharge}
//                     value={selectedCustomer}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: base => ({ ...base, zIndex: 9999 })
//                     }}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md="6">
//                 <Form.Group>
//                   <Form.Label>Received By (Production Supervisor)</Form.Label>
//                   <Select
//                     isMulti
//                     options={staff}
//                     onChange={setSelectedStaff}
//                     onInputChange={handleSearchSupervisor}
//                     value={selectedStaff}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: base => ({ ...base, zIndex: 9999 })
//                     }}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//             <hr />
//             <Row>
//               <Col md="12">
//                 <Form.Group>
//                   <Form.Label>BOM Raw Material / Semi Finished Items</Form.Label>
//                   <Select
//                     options={PumpRawSemiProductOptions}
//                     onChange={handlePumpRawSemiProductSelect}
//                     value={selectedPumpRawSemiProduct}
//                     placeholder="Select Raw Material"
//                     noOptionsMessage={() => "No raw material found"}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: base => ({ ...base, zIndex: 9999 })
//                     }}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//             <br />
//             <div className="table-responsive">
//               <Table bordered>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Part Number</th>
//                     <th>Material Size</th>
//                     <th>MOC</th>
//                     <th>Required Qty</th>
//                     <th>Issued Qty</th>
//                     <th>balance Qty</th>
//                     <th>Unit of Measure (UOM)</th>
//                     <th>Remarks</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {productTableRaw.map((row, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{row.pumpPartItems?.label}</td>
//                       <td>{row.size}</td>
//                       <td>{row.moc}</td>
//                       <td>
//                         {row.pumprequiredquantity}
//                         {/* <Form.Control
//                           type="number"
//                           value={row.pumprequiredquantity}
//                           onChange={(e) => handleRawSemiInputChanges(index, 'pumprequiredquantity', e.target.value)}
//                         /> */}
//                       </td>
//                       <td>
//                         <Form.Control
//                           type="number"
//                           value={row.userIssuedQty}
//                           onChange={(e) => handleRawSemiInputChanges(index, 'userIssuedQty', e.target.value)}
//                         />
//                       </td>
//                       <td>{(row.availableQty || 0).toFixed(2)}</td>
//                       <td>
//                         <Form.Select
//                           value={row.uom}
//                           onChange={(e) => handleRawSemiInputChanges(index, 'uom', e.target.value)}
//                         >
//                           <option>Select Unit Of Measurement</option>
//                           <option value="bot">Bot</option>
//                           <option value="ctn">Ctn</option>
//                           <option value="days">Days</option>
//                           <option value="ft">Ft</option>
//                           <option value="hrs">Hrs</option>
//                           <option value="kg">Kg</option>
//                           <option value="grams">Grams</option>
//                           <option value="ltr">Ltr</option>
//                           <option value="mtr">Mtr</option>
//                           <option value="nos">Nos</option>
//                           <option value="pil">Pil</option>
//                           <option value="pkt">Pkt</option>
//                           <option value="set">Set</option>
//                           <option value="pcs">Pcs</option>
//                         </Form.Select>
//                       </td>
//                       <td>
//                         <textarea
//                           rows="2"
//                           cols="30"
//                           className="custom-textarea"
//                           value={row.remarks}
//                           onChange={(e) => handleRawSemiInputChanges(index, 'remarks', e.target.value)}
//                         />
//                       </td>
//                       <td>
//                         <Button variant="danger" onClick={() => handleRawSemiRemoveRow(index)}>X</Button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//             <Button type="submit" variant="primary">Submit</Button>
//           </Form>
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default PIssueSlipCreate;





import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Row, Col, Button, Table, Card } from 'react-bootstrap';
import Select from 'react-select';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import debounce from 'lodash/debounce';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';

const PIssueSlipCreate = () => {
  const navigate = useNavigate();

  const [issueslipdate, setissueslipdate] = useState(new Date().toISOString().split('T')[0]);
  const [stocktype, setSelectedstocktype] = useState({ value: 'outward', label: 'Outward' });

  const [storeInchargeSearch, setStoreInchargeSearch] = useState(encodeURIComponent(" "));
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [supervisorSearch, setSupervisorSearch] = useState(encodeURIComponent(" "));
  const [staff, setStaff] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);

  const [productionOrderSearch, setProductionOrderSearch] = useState(encodeURIComponent(" "));
  const [productionOrders, setProductionOrders] = useState([]);
  const [selectedProductionOrder, setSelectedProductionOrder] = useState(null);
  const [PumpRawSemiProductOptions, setPumpRawSemiProductOptions] = useState([]);
  const [selectedPumpRawSemiProduct, setselectedPumpRawSemiProduct] = useState(null);
  const [productTableRaw, setproductTableRaw] = useState([]);

  // Separate fields for display
  const [productionOrderNumber, setProductionOrderNumber] = useState('');
  const [productName, setProductName] = useState('');
  const [jobNumber, setJobNumber] = useState('');
  const [partNo, setPartNo] = useState('');
  const [quantity, setQuantity] = useState('');
  const [size, setSize] = useState('');

  const handleSearchStoreIncharge = debounce((inputValue) => {
    setStoreInchargeSearch(encodeURIComponent(inputValue));
  }, 500);

  const handleSearchSupervisor = debounce((inputValue) => {
    setSupervisorSearch(encodeURIComponent(inputValue));
  }, 500);

  const handleSearchProductionOrder = debounce((inputValue) => {
    setProductionOrderSearch(encodeURIComponent(inputValue));
  }, 500);

  const fetchStoreIncharges = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}staff/page/0/10/asc/id/${storeInchargeSearch}`,
        { headers: authHeader() }
      );

      const staffMembers = response.data.Index || response.data.data;
      setCustomers(
        staffMembers.map((staff) => ({
          value: staff.id,
          label: `${staff.firstname} ${staff.lastname}`,
        }))
      );
    } catch (error) {
      console.error("Error fetching store incharges", error);
    }
  };

  const fetchSupervisors = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}staff/page/0/10/asc/id/${supervisorSearch}`,
        { headers: authHeader() }
      );
      const staffMembers = response.data.Index || response.data.data;
      setStaff(
        staffMembers.map((staff) => ({
          value: staff.id,
          label: `${staff.firstname} ${staff.lastname}`,
        }))
      );
    } catch (error) {
      console.error("Error fetching supervisors", error);
    }
  };

  const fetchProductionOrders = async () => {
    try {
      const res = await axios.get(`${BASE_URL}productionorder/bytype/page/0/10/asc/id/pump/${productionOrderSearch}`, {
        headers: authHeader(),
      });

      const list = res.data.Index || res.data.data;

      setProductionOrders(list.map(item => ({
        value: item.productionordernumber,
        label: `${item.productionordernumber} - ${item.productname} - ${item.jobnumber} - ${item.partno} - ${item.quantity} - ${item.size}`,
        productionordernumber: item.productionordernumber,
        productname: item.productname,
        jobnumber: item.jobnumber,
        partno: item.partno,
        quantity: item.quantity,
        size: item.size
      })));

    } catch (error) {
      console.error("Error fetching production orders", error);
    }
  };

  const fetchMaterialIssueSlipData = async (productId, productionOrderNumber) => {
    try {
      const response = await axios.get(
        `${BASE_URL}materialissueslip/getMaterialIssueSlip/Pump/WithProductAndPoNo/${productId}/${productionOrderNumber}`,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching material issue slip data", error);
      return [];
    }
  };

  const handleProductionOrderSelect = (selected) => {
    setSelectedProductionOrder(selected);
    
    // Set individual fields
    if (selected) {
      setProductionOrderNumber(selected.productionordernumber || '');
      setProductName(selected.productname || '');
      setJobNumber(selected.jobnumber || '');
      setPartNo(selected.partno || '');
      setQuantity(selected.quantity || '');
      setSize(selected.size || '');
      
      getPumpRawSemiProductProductData(selected.value);
    } else {
      setProductionOrderNumber('');
      setProductName('');
      setJobNumber('');
      setPartNo('');
      setQuantity('');
      setSize('');
    }
  };

  const getPumpRawSemiProductProductData = async (productionordernumber) => {
    try {
      const response = await axios.get(
        `${BASE_URL}productionorder/bomitemsbyproductionordernumber/${productionordernumber}`,
        { headers: authHeader() }
      );

      const popumpitems = response.data?.popumpitems || [];

      if (!popumpitems.length) {
        setPumpRawSemiProductOptions([]);
        return;
      }

      const finishedbom = popumpitems[0]?.finishedbom;

      if (!finishedbom || !finishedbom.bomPumpPartsItemsRawSemiService) {
        setPumpRawSemiProductOptions([]);
        return;
      }

      const pumpRawSemi = finishedbom.bomPumpPartsItemsRawSemiService;

      const options = pumpRawSemi.map((item) => ({
        value: item.product.id,
        label: item.description || `Item ${item.id}`,
        size: item.size || '',
        moc: item.moc || '',
        pumprequiredquantity: item.pumprequiredquantity || '',
        uom: item.uom || '',
        rate: item.rate || ''
      }));

      setPumpRawSemiProductOptions(options);
    } catch (error) {
      console.error('Error fetching tubing raw material from finishedbom', error);
    }
  };

  const handlePumpRawSemiProductSelect = async (selected) => {
    setselectedPumpRawSemiProduct(selected);

    // Check if the selected item already exists in the productTableRaw
    const isAlreadyAdded = productTableRaw.some(
      (item) => item.pumpPartItems.value === selected.value
    );

    if (isAlreadyAdded) {
      Swal.fire({
        icon: 'warning',
        title: 'Duplicate Entry',
        text: 'This raw material item is already added!',
      });
      return;
    }

    if (selected && selectedProductionOrder) {
      const materialSlipData = await fetchMaterialIssueSlipData(
        selected.value,
        selectedProductionOrder.value
      );

      const totalConsumed = materialSlipData
        .filter(item => item.product === selected.value)
        .reduce((sum, item) => sum + parseFloat(item.issuedquantity || 0), 0);

      const required = parseFloat(selected.pumprequiredquantity || 0);
      const issuedquantity = "";
      const available = required - totalConsumed;

      setproductTableRaw((prevRows) => [
        ...prevRows,
        {
          pumpPartItems: selected,
          description: selected.label,
          size: selected.size || '',
          moc: selected.moc || '',
          pumprequiredquantity: required,
          userIssuedQty: issuedquantity,
          totalConsumed: totalConsumed,
          availableQty: available,
          uom: selected.uom || '',
          rate: selected.rate || '',
          remarks: ''
        }
      ]);
    }
  };

  const handleRawSemiInputChanges = (index, field, value) => {
    const updatedRows = [...productTableRaw];
    const row = updatedRows[index];

    if (field === 'userIssuedQty' || field === 'pumprequiredquantity') {
      const userInput = parseFloat(value || 0);
      const requiredQty = parseFloat(row.pumprequiredquantity || 0);
      const totalConsumed = parseFloat(row.totalConsumed || 0);
      const totalIssued = userInput + totalConsumed;

      if (totalIssued > requiredQty) {
        Swal.fire({
          icon: 'warning',
          title: 'Quantity Limit Exceeded',
          html: `Required quantity is <strong>${requiredQty}</strong>.<br>Total issued (entered + already used) is <strong>${totalIssued}</strong>.<br>Please enter a valid quantity.`,
        });

        return;
      }

      if (field === 'userIssuedQty') {
        updatedRows[index]['userIssuedQty'] = value;
      } else {
        updatedRows[index][field] = userInput;
      }

      updatedRows[index]['availableQty'] =
        parseFloat(updatedRows[index]['pumprequiredquantity'] || 0) -
        (parseFloat(updatedRows[index]['userIssuedQty'] || 0) + totalConsumed);
    } else {
      updatedRows[index][field] = value;
    }

    setproductTableRaw(updatedRows);
  };

  const handleRawSemiRemoveRow = (index) => {
    const updatedRows = productTableRaw.filter((_, rowIndex) => rowIndex !== index);
    setproductTableRaw(updatedRows);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedProductionOrder) {
      alert('Please select a production order.');
      return;
    }

    const payload = {
      type: "Pump",
      issueslipdate,
      stocktype: stocktype?.value || '',
      issuedby: selectedCustomer.map(staff => ({ id: staff.value })),
      receivedby: selectedStaff.map(staff => ({ id: staff.value })),
      productionordernumber: selectedProductionOrder.value,
      jobnumber: jobNumber,
      partno: partNo,
      warehouse: {
        id: "1" // Assuming warehouse ID is 1, adjust as necessary
      },

      materialissuewithbomrawsemiservicespump: productTableRaw.map(row => ({
        product: {
          id: row.pumpPartItems.value
        },
        partname: row.partname || "",
        description: row.description || '',
        materialsize: row.size || '',
        moc: row.moc || '',
        requiredquantity: row.pumprequiredquantity || '',
        issuedquantity: row.userIssuedQty || '',
        uom: row.uom || '',
        rate: row.rate || '',
        remark: row.remarks
      }))
    };

    console.log(payload)

    try {
      const response = await axios.post(`${BASE_URL}materialissueslip`, payload, {
        headers: authHeader()
      });

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Data submitted successfully!',
        confirmButtonText: 'OK'
      }).then(() => {
        navigate("/issue-slip-list/1");
      });

    } catch (error) {
      console.error("Error submitting data", error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Failed to submit data.',
        confirmButtonText: 'Try Again'
      });
    }
  };

  useEffect(() => {
    fetchStoreIncharges();
  }, [storeInchargeSearch]);

  useEffect(() => {
    fetchSupervisors();
  }, [supervisorSearch]);

  useEffect(() => {
    fetchProductionOrders();
  }, [productionOrderSearch]);

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>MATERIAL ISSUE SLIP</h6>
          <Link to="/issue-slip-list/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <div className="container">
          <br />
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Production Order Number</Form.Label>
                  <Select
                    options={productionOrders}
                    onChange={handleProductionOrderSelect}
                    onInputChange={handleSearchProductionOrder}
                    value={selectedProductionOrder}
                    placeholder="Search or select production order"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Separate fields showing production order details */}
            {selectedProductionOrder && (
              <Row className="mt-3">
                <Col md="2">
                  <Form.Group>
                    <Form.Label>PO Number</Form.Label>
                    <Form.Control type="text" value={productionOrderNumber} readOnly />
                  </Form.Group>
                </Col>
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control type="text" value={productName} readOnly />
                  </Form.Group>
                </Col>
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Job Number</Form.Label>
                    <Form.Control type="text" value={jobNumber} readOnly />
                  </Form.Group>
                </Col>
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Part No</Form.Label>
                    <Form.Control type="text" value={partNo} readOnly />
                  </Form.Group>
                </Col>
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control type="text" value={quantity} readOnly />
                  </Form.Group>
                </Col>
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Size</Form.Label>
                    <Form.Control type="text" value={size} readOnly />
                  </Form.Group>
                </Col>
              </Row>
            )}

            <hr />

            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Stock Type</Form.Label>
                  <Select
                    options={[{ value: 'inward', label: 'Inward' }, { value: 'outward', label: 'Outward' }]}
                    onChange={setSelectedstocktype}
                    value={stocktype}
                  />
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group>
                  <Form.Label>Issue Slip Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={issueslipdate}
                    onChange={(e) => setissueslipdate(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group>
                  <Form.Label>Issued By (Store Incharge)</Form.Label>
                  <Select
                    isMulti
                    options={customers}
                    onChange={setSelectedCustomer}
                    onInputChange={handleSearchStoreIncharge}
                    value={selectedCustomer}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Received By (Production Supervisor)</Form.Label>
                  <Select
                    isMulti
                    options={staff}
                    onChange={setSelectedStaff}
                    onInputChange={handleSearchSupervisor}
                    value={selectedStaff}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>BOM Raw Material / Semi Finished Items</Form.Label>
                  <Select
                    options={PumpRawSemiProductOptions}
                    onChange={handlePumpRawSemiProductSelect}
                    value={selectedPumpRawSemiProduct}
                    placeholder="Select Raw Material"
                    noOptionsMessage={() => "No raw material found"}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <br />
            <div className="table-responsive">
              <Table bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Part Number</th>
                    <th>Material Size</th>
                    <th>MOC</th>
                    <th>Required Qty</th>
                    <th>Issued Qty</th>
                    <th>balance Qty</th>
                    <th>Unit of Measure (UOM)</th>
                    <th>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {productTableRaw.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.pumpPartItems?.label}</td>
                      <td>{row.size}</td>
                      <td>{row.moc}</td>
                      <td>
                        {row.pumprequiredquantity}
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={row.userIssuedQty}
                          onChange={(e) => handleRawSemiInputChanges(index, 'userIssuedQty', e.target.value)}
                        />
                      </td>
                      <td>{(row.availableQty || 0).toFixed(2)}</td>
                      <td>
                        <Form.Select
                          value={row.uom}
                          onChange={(e) => handleRawSemiInputChanges(index, 'uom', e.target.value)}
                        >
                          <option>Select Unit Of Measurement</option>
                          <option value="bot">Bot</option>
                          <option value="ctn">Ctn</option>
                          <option value="days">Days</option>
                          <option value="ft">Ft</option>
                          <option value="hrs">Hrs</option>
                          <option value="kg">Kg</option>
                          <option value="grams">Grams</option>
                          <option value="ltr">Ltr</option>
                          <option value="mtr">Mtr</option>
                          <option value="nos">Nos</option>
                          <option value="pil">Pil</option>
                          <option value="pkt">Pkt</option>
                          <option value="set">Set</option>
                          <option value="pcs">Pcs</option>
                        </Form.Select>
                      </td>
                      <td>
                        <textarea
                          rows="2"
                          cols="30"
                          className="custom-textarea"
                          value={row.remarks}
                          onChange={(e) => handleRawSemiInputChanges(index, 'remarks', e.target.value)}
                        />
                      </td>
                      <td>
                        <Button variant="danger" onClick={() => handleRawSemiRemoveRow(index)}>X</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <Button type="submit" variant="primary">Submit</Button>
          </Form>
        </div>
      </Card>
    </div>
  );
};

export default PIssueSlipCreate;
